export const BASE_TEXTS = {
   NetworkError: 'Sorry, we encountered a network error. Please check your connection and try again',
};

export const MOD_TEXTS = {
   ErrTitle: 'We have a problem',
   OkTitle: "You're all set",
};

export const NEWSLETTERS_TEXTS = {
   MinCategories: 'Please, select at least one category',
};